import React from "react";
import styles from "./RegisterOrderForm.module.css";

type FormFieldProps = {
	label?: string;
	/** Id of the control, so clicking the label focuses it. */
	htmlFor?: string;
	/** Red asterisk after the label. Visual only — the rules themselves live in the page's save. */
	required?: boolean;
	/** Muted text after the label, e.g. "optional". */
	optionalTag?: string;
	/** Shown under the control in red, in place of the hint. */
	error?: React.ReactNode;
	hint?: React.ReactNode;
	className?: string;
	children: React.ReactNode;
};

/** Label, control and the one line under it, laid out the same way for every input on the form. */
const FormField = ({
	label,
	htmlFor,
	required,
	optionalTag,
	error,
	hint,
	className,
	children,
}: FormFieldProps) => (
	<div className={`${styles.field} ${className ?? ""}`}>
		{label && (
			<label htmlFor={htmlFor} className={styles.fieldLabel}>
				{label}
				{required && (
					<span className={styles.requiredMark} aria-hidden="true">
						*
					</span>
				)}
				{optionalTag && (
					<span className={styles.optionalTag}>{optionalTag}</span>
				)}
			</label>
		)}
		{children}
		{error ? (
			<p className={styles.fieldError} role="alert">
				{error}
			</p>
		) : (
			hint && <div className={styles.fieldHint}>{hint}</div>
		)}
	</div>
);

export default FormField;
